import { render } from "./OrderModal.vue?vue&type=template&id=a1307a10&ts=true"
import script from "./OrderModal.vue?vue&type=script&lang=ts"
export * from "./OrderModal.vue?vue&type=script&lang=ts"

import "./OrderModal.vue?vue&type=style&index=0&id=a1307a10&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__